import { Pagination } from '@/domain/entities/Pagination'

export class TopMenuData {
  public id: number
  public name: string
  public key: string
  public value: number
  public color: string
  constructor(
    id: number,
    name: string,
    key: string,
    value: number,
    color: string
  ) {
    this.id = id
    this.name = name
    this.key = key
    this.value = value
    this.color = color
  }
}

export class ChartData {
  public value: number
  public category_id: string
  public category_name: string
  constructor(value: number, category_id: string, category_name: string) {
    ;(this.value = value), (this.category_id = category_id)
    this.category_name = category_name
  }
}

export class AccessRateChartsData {
  public month: number
  public percentage: number
  public totalUserAccess: number
  public totalUserVisit: number
  constructor(
    month: number,
    percentage: number,
    totalUserAccess: number,
    totalUserVisit: number
  ) {
    this.month = month
    this.percentage = percentage
    this.totalUserAccess = totalUserAccess
    this.totalUserVisit = totalUserVisit
  }
}

export class TopVisitData {
  public id: number
  public title: string
  public total_visit: string
  public total_user: string
  constructor(
    id: number,
    title: string,
    total_user: string,
    total_visit: string
  ) {
    this.id = id
    this.title = title
    this.total_user = total_user
    this.total_visit = total_visit
  }
}

export class TopVisitByType {
  public type_name: string
  public total_visit: string
  public total_user: string
  constructor(type_name: string, total_user: string, total_visit: string) {
    this.type_name = type_name
    this.total_user = total_user
    this.total_visit = total_visit
  }
}

export class MaterialVisitDetail {
  public title: string
  public category: string
  public car_type: string
  public total_visit: number
  public total_user: number
  public id: number
  public file_code: string
  public created_date: string
  constructor(
    title: string,
    file_code: string,
    category: string,
    car_type: string,
    total_visit: number,
    total_user: number,
    created_date: string,
    id: number
  ) {
    this.file_code = file_code
    this.title = title
    this.category = category
    this.car_type = car_type
    this.total_visit = total_visit
    this.total_user = total_user
    this.id = id
    this.created_date = created_date
  }
}

export class ExportData {
  public link: string
  constructor(link: string) {
    this.link = link
  }
}

export class Export {
  public success: boolean
  public message: string
  public data?: ExportData[]

  constructor(success: boolean, message: string, data?: ExportData[]) {
    this.success = success
    this.message = message
    this.data = data
  }
}

export class TrainingMaterialReport {
  public success: boolean
  public message: string
  public topMenu?: TopMenuData[]
  public chart?: ChartData[]
  public accessRateCharts?: AccessRateChartsData[]
  public topVisit?: TopVisitData[]
  public topVisitType?: TopVisitByType[]
  public materialVisitDetail?: MaterialVisitDetail[]
  public materialVisitPagination?: Pagination

  constructor(
    success: boolean,
    message: string,
    topMenu?: TopMenuData[],
    chart?: ChartData[],
    accessRateCharts?: AccessRateChartsData[],
    topVisit?: TopVisitData[],
    topVisitByType?: TopVisitByType[],
    materialVisitDetail?: MaterialVisitDetail[],
    materialVisitPagination?: Pagination
  ) {
    this.success = success
    this.message = message
    this.topMenu = topMenu
    this.chart = chart
    this.accessRateCharts = accessRateCharts
    this.topVisit = topVisit
    this.topVisitType = topVisitByType
    this.materialVisitDetail = materialVisitDetail
    this.materialVisitPagination = materialVisitPagination
  }
}
